import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import { Section, Container } from '@components/global';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        connect: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "connect" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }

        design: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "design" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }

        distribute: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "distribute" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="how">
        <Container>
          <Grid>
            <div>
              <h2>Connect your data</h2>
              <p>
              Connect DataFlip to your Google Analytics account and we'll fetch the latest stats straight from the API.
              </p>
            </div>
            <Art>
              <Img fluid={data.connect.childImageSharp.fluid} />
            </Art>
          </Grid>
          <Grid inverse>
            <Art>
              <Img fluid={data.design.childImageSharp.fluid} />
            </Art>
            <div>
              <h2>Design</h2>
              <p>
              Our team designs an update on your site performance and visitors, carefully laid out in Microsoft Powerpoint.
              </p>
            </div>
          </Grid>
          <Grid>
            <div>
              <h2>Distribute</h2>
              <p>
              We'll deliver it straight to your inbox or cloud storage service. It's easy colleagues to the distribution list so the whole team gets the latest info.
              </p>
            </div>
            <Art>
              <Img fluid={data.distribute.childImageSharp.fluid} />
            </Art>
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-gap: 40px;
  text-align: right;
  align-items: center;
  justify-items: center;
  margin: 24px 0;

  ${props =>
    props.inverse &&
    `
    text-align: left;
    grid-template-columns: 3fr 2fr;
  `}

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: left;
    margin-bottom: 96px;

    &:last-child {
      margin-bottom: 24px;
    }

    ${props =>
      props.inverse &&
      `
        ${Art} {
          order: 2;
        }
    `}
  }
`;

const Art = styled.figure`
  margin: 0;
  max-width: 380px;
  width: 100%;
`;

export default About;
